import React from 'react';
import Select from '../../../components/ui/Select';

const FollowerRangeSelect = ({ platform, value, onChange, error }) => {
  const followerRanges = [
    { value: '1k-10k', label: '1K - 10K followers' },
    { value: '10k-50k', label: '10K - 50K followers' },
    { value: '50k-100k', label: '50K - 100K followers' },
    { value: '100k-500k', label: '100K - 500K followers' },
    { value: '500k-1m', label: '500K - 1M followers' },
    { value: '1m+', label: '1M+ followers' }
  ];

  return (
    <div className="mb-4">
      <Select
        label={`${platform?.charAt(0)?.toUpperCase() + platform?.slice(1)} Followers`}
        description="Select your approximate follower count"
        options={followerRanges}
        value={value}
        onChange={(selectedValue) => onChange(platform, selectedValue)}
        error={error}
        placeholder="Choose follower range"
      />
    </div>
  );
};

export default FollowerRangeSelect;